export enum ModalName {
	None = 'None',
	SendDataModal = 'SendDataModal',
	ConfirmationOfSendingModal = 'ConfirmationOfSendingModal',
}
